export const TDA_LINK = `https://www.pokertda.com/view-poker-tda-rules/`;
export const ROBERTS_RULES_LINK = `https://www.pagat.com/docs/RobsPkrRules11.pdf`;
export const APP_INFO_EMAIL = `info@pokercity.com`;
export const APP_PRIVACY_EMAIL = `privacy@pokercity.com`;
